import styled, { keyframes } from "styled-components";

export const BounceIn = keyframes`
    0% {
      opacity: 0;
      transform: translateY(16px) scale(0.3);
    }
    40% {
      transform: translateY(-2px) scale(1.1);
    }
    100% {
      opacity: 1;
      transform: translateY(0px) scale(1);
    }
`;

export const AppearRight = keyframes`
  0%{
    opacity: 0;
    transform: translateX(16px);
  }

  100%{
    opacity: 1;
    transform: translateX(0px);
  }
`;

export const DissapearLeft = keyframes`
  0%{
    transform: translateX(0px) translateY(0) scale(1);
  }

  100%{
    opacity: 0.5;
    transform: translateX(32px) translateY(12px) scale(0.3);
  }
`;


// WEBPACK FOOTER //
// ./src/components/MobNav/animations.js